import { isRouteErrorResponse, useRouteError } from 'react-router'
import {
  ErrorBody,
  RouteErrorBody,
  UnknownErrorBody,
} from '#ui/Errors/index.tsx'
import { WebsiteErrWrap } from '#ui/Errors/WebsiteErrWrap.tsx'

export function WebsiteErrorBoundary() {
  const error = useRouteError()

  return (
    <WebsiteErrWrap>
      {isRouteErrorResponse(error) ? (
        <RouteErrorBody error={error} />
      ) : error instanceof Error ? (
        <ErrorBody error={error} />
      ) : (
        <UnknownErrorBody />
      )}
    </WebsiteErrWrap>
  )
}
